'use client'

import { FormProvider } from 'react-hook-form'

/**
 * @group Components
 * 
 * @summary
 * <blockquote>The main Form provider component from react-hook-form.</blockquote>
 * 
 * @example
 * ```typescript
 * import { Form } from '@shared/ui'
 * 
 * <Form {...form}>
 *   
 * </Form>
 * ```
 */
export const Form = FormProvider 